import { AddressFields } from '../../../account-info/models/form-models';

const institutionDetailMailingAddressRequiredSchemaSimple: AddressFields = {
  country: true,
  address1: true,
  address2: false,
  address3: false,
  city: true,
  state: false,
  postalCode: false,
};

const institutionDetailMailingAddressRequiredSchemaComplete: AddressFields = {
  country: true,
  address1: true,
  address2: false,
  address3: false,
  city: true,
  state: true,
  postalCode: true,
};

export function GetInstitutionDetailMailingAddressRequiredSchema(
  countryCode: string,
): AddressFields {
  return countryCode === 'MX' || countryCode === 'US' || countryCode === 'CA'
    ? institutionDetailMailingAddressRequiredSchemaComplete
    : institutionDetailMailingAddressRequiredSchemaSimple;
}
